import { render, staticRenderFns } from "./XwpVideoLiveness.vue?vue&type=template&id=63f22160&"
import script from "./XwpVideoLiveness.vue?vue&type=script&lang=js&"
export * from "./XwpVideoLiveness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports